"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeQuotes = exports.FontFaceRepository = void 0;
var _fontfaceobserver = _interopRequireDefault(require("fontfaceobserver"));
var _DOM = require("redhotmagma-graphics-editor/Utils/DOM");
var _configuration = require("../../../configuration");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var removeQuotes = exports.removeQuotes = function removeQuotes(str) {
  return str && str.replace(/"/g, '');
};
var FontFaceRepository = exports.FontFaceRepository = function (_ref) {
  var loadTimeout = _ref.loadTimeout;
  var repository = new Map();
  var request = function request(name) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var key = [name].concat(_toConsumableArray(Object.values(params))).join('-');
    if (!repository.has(key)) {
      var fontFaceObserver = new _fontfaceobserver["default"](name, params);
      repository.set(key, fontFaceObserver.load(null, loadTimeout));
    }
    return repository.get(key);
  };
  var collectFromElement = function collectFromElement(element) {
    var fonts = [];
    (0, _DOM.traverse)(element, function (node) {
      if (node.style && node.style.fontFamily) {
        var _node$style = node.style,
          fontFamily = _node$style.fontFamily,
          fontWeight = _node$style.fontWeight,
          fontStyle = _node$style.fontStyle;
        fonts.push(request(removeQuotes(fontFamily), {
          weight: fontWeight || 'normal',
          style: fontStyle || 'normal'
        }));
      }
    });
    return Promise.all(fonts);
  };
  var collectFromHTML = function collectFromHTML(htmlStr) {
    var element = document.createElement('div');
    element.innerHTML = htmlStr;
    return collectFromElement(element);
  };
  return {
    request: request,
    collectFromElement: collectFromElement,
    collectFromHTML: collectFromHTML
  };
}({
  loadTimeout: (0, _configuration.getConf)('network.timeout', 60000)
});